import React from 'react';
import get from 'lodash/get';
import { InfiniteStoryList } from '../../rows/infinite-story-list';
import { PageHeading } from '../../molecules/page-heading';
import './author.m.css';
import RightSideBar from '../../molecules/right-side-bar';

class AuthorPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showmore: false
    };

    this.viewmore = this.viewmore.bind(this);
  }

  viewmore() {
    this.setState({ showmore: !this.state.showmore });
  }

  render() {
    const params = {
      stories: get(this.props, ['data', 'stories']),
      baseApi: get(this.props, ['data', 'baseApi']),
      fullWidthResult: true,
      hostImage: get(this.props, ['config', 'cdn-image']),
      hideAuthor: true
    };

    const heading =
      get(this.props, ['data', 'stories']).length > 0
        ? get(this.props, ['data', 'author', 'name'])
        : 'No stories for this author';
    const avatar = get(this.props, ['data', 'author', 'avatar-url']) ?? heading?.slice(0, 1);
    const socials = get(this.props, ['data', 'author', 'social']) ?? {};
    const bio = get(this.props, ['data', 'author', 'bio']);
    const halfbio = bio?.substring(0, 130).concat('...');
    const socialNames = Object.keys(socials);
    let socialUrl;
    const validSocials = ['twitter', 'instagram', 'facebook', 'linkedin'];

    return (
      <div className="container">
        <div styleName="author-story-list" className="row-section sidebar">
          <div>
            <div styleName="author-heading">
              {avatar.length < 2 ? (
                <div styleName="author-name">{heading.slice(0, 1)}</div>
              ) : (
                <img className="author-image" src={avatar} />
              )}
              <div styleName="author-details">
                <PageHeading
                  title={heading}
                  hasStories={get(this.props, ['data', 'stories'], '').length > 0}
                  count={get(this.props, ['data', 'total'], 0)}
                  bio={this.state.showmore ? bio : halfbio}
                  viewmore={this.viewmore}
                  showmore={this.state.showmore}
                />
                <div styleName="social">
                  {socials &&
                    Object.entries(socials).map(([platform, social], i) => {
                      const socialUrl = social?.url || `https://www.${platform}.com/${social?.handle ?? ''}`;
                      return (
                        <a key={i} href={socialUrl} target="_blank" rel="noreferrer">
                          <span
                            styleName={
                              validSocials.includes(socialNames[i])
                                ? `${socialNames[i]}-icon icon`
                                : 'icon'
                            }
                            className={`icon-ic_${socialNames[i]}`}
                          ></span>
                        </a>
                      );
                    })}
                </div>
              </div>
            </div>
            <div styleName="infinite-container">
              <InfiniteStoryList {...params} />
            </div>
          </div>
          <div>
            <RightSideBar />
          </div>
        </div>
      </div>
    );
  }
}

export { AuthorPage };
